import {type AuthorType, type TopicColorMap} from './types';

export const AUTHOR_TYPES: AuthorType[] = [
  'All',
  'Community',
  'Partner',
  'W&B',
];

// Colors based on the plan (Blue, Purple, etc.) - can be adjusted
export const TOPIC_COLORS: TopicColorMap = {
  // Existing / Legacy
  Agents: {
    backgroundColor: '#FFB057', // Orange
    textColor: '#FFFFFF',
  },
  'Reinforcement Learning': {
    backgroundColor: '#D67DFF', // Purple
    textColor: '#FFFFFF',
  },
  RAG: {
    backgroundColor: '#D67DFF', // Purple
    textColor: '#FFFFFF',
  },
  Trust: {
    backgroundColor: '#2BC2D1', // Teal
    textColor: '#FFFFFF',
  },
  GenAI: {
    backgroundColor: '#F2F2F2', // Light Gray
    textColor: '#2B3038',
  },
  LLM: {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },
  Articles: {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },

  // Authors
  Community: {
    backgroundColor: '#E6F4F1', // Light Teal
    textColor: '#2B3038',
  },
  Partner: {
    backgroundColor: '#E6F4F1',
    textColor: '#2B3038',
  },
  'W&B': {
    backgroundColor: '#E6F4F1',
    textColor: '#2B3038',
  },

  // AI Agent Observability
  Evaluations: {
    backgroundColor: '#FFB057',
    textColor: '#2B3038',
  },
  'Agent building and monitoring': {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },
  Inference: {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },
  'Safety and scoring': {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },

  // Build Models
  'Computer vision': {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },
  'Building LLMs': {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },
  NLP: {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },
  'Model ops': {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },

  // About W&B
  'Product announcements': {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },
  Integrations: {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },
  Events: {
    backgroundColor: '#D67DFF',
    textColor: '#2B3038',
  },
  Podcast: {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },

  // Default fallback matching the reference image style
  default: {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },
};

export const AUTHOR_TAG_MAPPING: Record<string, AuthorType> = {
  // Map specific tags to author types if needed
  community: 'Community',
  partner: 'Partner',
  wandb: 'W&B',
  'weights-biases': 'W&B',
};

export type TopicItem = {
  name: string;
  link: string;
};

export type TopicGroup = {
  name: string;
  items: TopicItem[];
};

export const TOPIC_GROUPS: TopicGroup[] = [
  {
    name: 'AI agent observability',
    items: [
      {
        name: 'Evaluations',
        link: '/fully-connected/blog/tag/evaluations',
      },
      {
        name: 'Agent building and monitoring',
        link: '/fully-connected/blog/tag/agents',
      },
      {
        name: 'Inference',
        link: '/fully-connected/blog/tag/inference',
      },
      {
        name: 'Safety and scoring',
        link: '/fully-connected/blog/tag/safety-scoring',
      },
    ],
  },
  {
    name: 'Build models',
    items: [
      {
        name: 'Computer vision',
        link: '/fully-connected/blog/tag/computer-vision',
      },
      {
        name: 'Building LLMs',
        link: '/fully-connected/blog/tag/llm',
      },
      {name: 'NLP', link: '/fully-connected/blog/tag/nlp'},
      {
        name: 'Model ops',
        link: '/fully-connected/blog/tag/model-ops',
      },
    ],
  },
  {
    name: 'About Weights & Biases',
    items: [
      {
        name: 'Product announcements',
        link: '/fully-connected/blog/tag/feature-releases',
      },
      {
        name: 'Integrations',
        link: '/fully-connected/blog/tag/framework-integration',
      },
      {name: 'Events', link: 'https://wandb.ai/site/resources/events/'},
      {name: 'Podcast', link: 'https://wandb.ai/site/resources/podcast/'},
    ],
  },
];
